
































































import { Component, Prop, Vue } from "vue-property-decorator";
import { splitString } from "@/services/strings";

import Progress from "./progress.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import { size, type } from "@/config/files.config.json";
import { AxiosRequestConfig } from "axios";
import { pics } from "@/config/host.config";

interface IImageParams {
  poster_name: string | null;
  lang: string | undefined;
  path: string;
  name: boolean;
  resizewidth: number | undefined;
  resizeheight: number | undefined;
}

interface IProgress {
  name: string;
  variant: string;
  progress: number;
  type: boolean;
  size: boolean;
}

interface IWH {
  width: number;
  height: number;
}

@Component({
  components: {
    StandartModal,
    "progress-component": Progress,
    submit: SubmitResetButtonGroop,
  },
})
export default class UploadImages extends Vue {
  @Prop({ type: String, default: null }) img_type!: string;
  @Prop({ type: String, default: null }) folder!: string;
  @Prop({ type: String, default: pics.newupload }) host!: string;
  @Prop({ type: String, default: null }) locale!: string;
  @Prop({ type: Object, default: null }) widthHeight!: IWH;

  files: Array<File> = [];
  fileList: FileList | null = null;
  progress: Array<IProgress> = [];
  posters_name: Array<string> = [];
  saweName = true;
  showUpload = true;

  // progress
  poster_prodress_variant = "primary";
  poster_value_progress = 0;
  posters_progress = false;

  size = size.image;
  type = type.image;

  $refs!: {
    file: HTMLInputElement;
  };

  changeFiles(): void {
    this.fileList = this.$refs.file.files;
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (!this.fileList || !this.fileList.length)
      return this.onError("File list is empty");

    for (let i = 0; i < this.fileList.length; i++) {
      this.uploadFormData(this.fileList[i], i);
    }
  }

  onReset(): void {
    this.files = [];
    this.progress = [];
    this.posters_name = [];
  }

  uploadFormData(file: File | null, i: number): void {
    if (!file) return this.onError("File not found");

    const name = file.name;
    const type = this.isCorrectFormat(file.type);
    const size = file.size <= this.size ? true : false;
    const variant = type && size ? "primary" : "danger";
    const progress: IProgress = {
      name,
      variant,
      progress: 0,
      type,
      size,
    };

    this.progress.push(progress);
    this.files.push(file);
    let formData = new FormData();
    formData.append("poster", file);

    this.sendNewFile(formData, name, i);
  }

  async sendNewFile(data: FormData, name: string, i: number): Promise<void> {
    const params: IImageParams = {
      path: this.folder,
      name: this.saweName,
      resizewidth: this.widthHeight ? this.widthHeight.width : undefined,
      resizeheight: this.widthHeight ? this.widthHeight.height : undefined,
      poster_name: name,
      lang: this.locale ? this.locale : undefined,
    };

    const config = {
      headers: {
        "Content-Type": "multipart/form-data;charset=utf-8",
      },
      onDownloadProgress: (e: ProgressEvent) => {
        this.progress[i].progress = Math.round((e.loaded * 100) / e.total);
      },
      params: params,
    };
    try {
      const image = await this.$axios.post(this.host, data, config);
      if (image.status === 200) this.$emit("name", image.data);
    } catch (error) {
      this.progress[i].variant = "danger";
      console.error(error);
    }
    if (i == this.files.length - 1) this.$bvModal.hide("upload-images");
  }

  isCorrectFormat(string: string | undefined): boolean {
    if (string === undefined) return false;
    const split_arr = splitString(string, "/");
    return this.type.includes(split_arr[split_arr.length - 1]);
  }

  onError(text: string, type = "warn"): void {
    this.$notify({
      group: "global",
      text,
      type,
    });
  }
}
